// Model validation utilities - validation disabled to allow all models
export const isModelSupported = (modelId: string): boolean => {
  // Allow all models - let the backend handle validation
  return true;
};

export const getUnsupportedModelMessage = (modelId: string): string => {
  return `⚠️ Model not enabled

"${modelId}" isn't approved in this account. Request access in #llm-playground.`;
};

// Model inference type classification utilities
export interface ResourceItem {
  id: string;
  name?: string;
  inferenceType?: string;
  inferenceTypesSupported?: string[];
  provider?: string;
}

/**
 * Get all inference types supported by a model
 */
export const getModelInferenceTypes = (model: ResourceItem): string[] => {
  const raw = model.inferenceTypesSupported;
  if (Array.isArray(raw) && raw.length > 0) {
    return raw.map((t) => String(t).toUpperCase());
  }
  const single = model.inferenceType;
  return single ? [String(single).toUpperCase()] : [];
};

/**
 * Check if model only supports INFERENCE_PROFILE (not ON_DEMAND)
 * Used by backend for model ID resolution
 */
export const isInferenceProfileOnly = (model: ResourceItem): boolean => {
  const types = getModelInferenceTypes(model);
  return types.includes('INFERENCE_PROFILE') && !types.includes('ON_DEMAND');
};
